/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 $(window).scroll(function() {
    if ( $(window).scrollTop() > 25){
        $('.header').addClass('is--sticky');
        $('.header--cutom').addClass('is--sticky');
    }else{
        $('.header').removeClass('is--sticky');
        $('.header--cutom').removeClass('is--sticky');
    }
    if($('.shopify-section--slideshow+.shopify-section').length){
        var slidex = $('.shopify-section--slideshow+.shopify-section').offset().top;
        if ( $(window).scrollTop() >= slidex){
           $('.header').addClass('is--show');       
        }else {
          $('.header').removeClass('is--show');      
          
        }
    }
   
  });
  $(window).on('load resize orientationchange', function() {
    if ($(window).width() > 767) {
      $('.product-facet__filters.drawer').removeClass('drawer--from-left');
    }else{
      $('.product-facet__filters.drawer').addClass('drawer--from-left');
    }
    $('[data-slick-slider]').each(function(){
      var $slider = $(this);
      if ($(window).width() > 740) {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }
      }
      else{
          if (!$slider.hasClass('slick-initialized')) {
              $slider.slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  dots:true,
                  infinite: false,
                  variableWidth: true
              });
          }
      }
    })   
    $('.header__icon-wrapper[aria-controls="mobile-menu-drawer"]').on('click').off('click', function(){
      if ($(window).width() < 741) {
        $(this).addClass('is-open');
      }
    })   

    var $slider_about = $('[data-about-slide]');
    if (!$slider_about.hasClass('slick-initialized')) {
      $slider_about.slick({
          slidesToShow: 2.3,
          slidesToScroll: 1,
          arrows: false,
          dots:false,
          centerMode: false,
          infinite: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.5
              }
            }
          ]
      });
  }
  })
  
$(document).ready(function(){
  const buttonGroup = $(".button-group-mb a");
  const formProduct = $(".c-card-product");
  const overplay = $(".PageOverlay");
  const pageOverlay = $(".PageOverlay");
  const iconClose = $(".c-card-product .icon.icon-close");
  const iconText = $(".c-text-close");
  buttonGroup.click(function() {
    $('body').addClass("lock-all");
    formProduct.addClass("is-showing-popup");
    overplay.addClass("is-visible");
  });
    
  iconClose.click(function() {
      $('body').removeClass("lock-all");
      formProduct.removeClass("is-showing-popup");
      overplay.removeClass("is-visible");
  });
    
  iconText.click(function() {
      $('body').removeClass("lock-all");
      formProduct.removeClass("is-showing-popup");
      overplay.removeClass("is-visible");
  });
    
  pageOverlay.click(function() {
      $('body').removeClass("lock-all");
      formProduct.removeClass("is-showing-popup");
      overplay.removeClass("is-visible");
  });
  //STAFF SLIDE
  function intervalFuncs() {
         if ($('.staffstart-shopify-app-container .sc-kYxDKI').length){
           $('.staffstart-custom').show();
         }else{
            $('.staffstart-custom').hide();
         }
        if( $('.staffstart-shopify-app-container .sc-koXPp').length > 4 && $(window).width() > 999 ){
           var $slider_staff = $('.staffstart-shopify-app-container .sc-ZbTNT');
            if (!$slider_staff.hasClass('slick-initialized')) {
            $slider_staff.slick({
                dots: false,
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                nextArrow: '<span class="product-list__arrow prev-next-button prev-next-button--next"><svg xmlns="http://www.w3.org/2000/svg" width="38.577" height="10.4" viewBox="0 0 38.577 10.4"><g transform="translate(-250.5 -832.983)"><g transform="translate(-4115.172 458.513)"><path d="M4423,375l4.669,4.67-4.669,4.67" transform="translate(-24.481 0)" fill="none" stroke="#111" stroke-miterlimit="10" stroke-width="1.5"/><line x1="37.517" transform="translate(4365.672 379.728)" fill="none" stroke="#111" stroke-miterlimit="10" stroke-width="1.5"/></g></g></svg></span>',
                prevArrow: '<span class="product-list__arrow prev-next-button prev-next-button--prev"><svg xmlns="http://www.w3.org/2000/svg" width="38.577" height="10.4" viewBox="0 0 38.577 10.4"><g transform="translate(289.077 843.383) rotate(180)"><g transform="translate(-4115.172 458.513)"><path d="M4423,375l4.669,4.67-4.669,4.67" transform="translate(-24.481 0)" fill="none" stroke="#111" stroke-miterlimit="10" stroke-width="1.5"/><line x1="37.517" transform="translate(4365.672 379.728)" fill="none" stroke="#111" stroke-miterlimit="10" stroke-width="1.5"/></g></g></svg></span>',    
                responsive: [
                  {
                  breakpoint: 2000,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false
                  }
                },
                {
                  breakpoint: 1199,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false
                  }
                }
              ]
             });   
            }
    }
  }
  vary = setInterval(intervalFuncs, 1000);
  
  if ($('.product-facet__meta-bar').length){
      $(window).on('scroll', function () {
        if (($(window).scrollTop() > 200 )){
          $('#mobile-facet-toolbar').addClass('is-toolbar-scroll');
        } else {
          $('#mobile-facet-toolbar').removeClass('is-toolbar-scroll');
        }
      });
  }
   
   
  // clear filters
  try{
      FilterApi.afterCall = function(filter) {
        setTimeout(function() {
          if($('.boost-pfs-filter-clear-all').length > -1){
            $('#js-resetFilter').click(function(){
              $('.boost-pfs-filter-clear-all').trigger('click');
            });
          }
           if($('.product-facet__filters').length > -1){
            $('.boost-pfs-filter-show-result').click(function(){
              $('.drawer__close-button').trigger('click');
            });
          }
        }, 0);
        
   
        if(filter.event_type == 'collection'){
          location.reload();
        }
   
      }
    }catch(err){
      //console.log(err);
    }
  if($('.template-collection .image-overlay').length == 0){
    $('#shopify-section-header').addClass('header--cutom');
    $('.shopify-section--collection-banner').addClass('collection-banner--custom');
  }

  const handleCloseAlertCart = () => {
    const closeBtn =  $('.js-close-alert');
    const layerAlert =  $('.js-layer-alert');
    const alert = $(".js-alert")

    layerAlert.on("click", function(){
      $('body').css('position', 'static');
      $('body').css('width', 'auto');
      alert.removeClass('is-active');
    });

    closeBtn.on("click", function(){
      alert.removeClass('is-active');
      $('body').css('position', 'static');
      $('body').css('width', 'auto');
    });
  }
  
  handleCloseAlertCart();
  
  // const string = $(".page-header__text-wrapper h1").text();
  // const containsJapanese = string.match(/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/);
  // containsJapanese.length && $(".page-header__text-wrapper h1").addClass("diffFont");

  // click show thumbnail
   if ($('.js-clickShowThumbnail').length > 0) {
     $('.js-clickShowThumbnail').click(function () {
       const idThumbnail = $(this).find('img').attr('alt');
       $('.product__thumbnail-list-inner .product__thumbnail-item[data-media-id='+idThumbnail+']').click();
     })
   }

   // Line restock
    
    $('.js-showLinePopup').click(function () {
      const $item = $('#oc-restock-button');
      const variantId = $(this).data("variant-id");
      $item.trigger('click');
      setTimeout(function () {
        $('#oc-restock-variant-selector option').map(function () {
          const variantIdLine = $(this).val();
    
          if ( variantIdLine == variantId ) {
            $(this).prop('selected', true);
            $(this).parent().change();
          }
        })
      },0)
      
    })

    // Control hide/show styling related
    const controlElements = document.querySelectorAll('.c-control-stylingRelated');
    if (controlElements.length > 0) {
        controlElements.forEach(element => {
            element.addEventListener('click', () => {
                const parentElement = element.parentElement;
                const productItemRelated = parentElement.querySelector('.c-productItemRelated');
    
                if (productItemRelated) {
                    if (productItemRelated.classList.contains('is-hide')) {
                        productItemRelated.classList.remove('is-hide');
                        element.querySelector('.c-control-stylingRelated__text').textContent = "CLOSE";
                    } else {
                        productItemRelated.classList.add('is-hide');
                        element.querySelector('.c-control-stylingRelated__text').textContent = "SHOW PRODUCTS";
                    }
                }
            });
        });
    }

    // Control hide/show search menu related
    $('.drawer__searchmenu-controls').on('click', function () {
      $('.drawer__searchmenu ul').slideToggle(250);
      const drawerSearchMenuText = $('.drawer__searchmenu-controls-text');
      if ($(drawerSearchMenuText).text() === "HIDE SUGGESTION") {
        $(drawerSearchMenuText).text("SHOW SUGGESTION");
      } else {
        $(drawerSearchMenuText).text("HIDE SUGGESTION");
      }
    });
  
    const inputPredictiveSearch = document.querySelector('.predictive-search__input');
    const drawerSearchMenu = document.querySelector('.drawer__searchmenu');
    inputPredictiveSearch.addEventListener('input', function () {
        if (inputPredictiveSearch.value.trim() === '') {
            drawerSearchMenu.style.display = '';
        } else {
            drawerSearchMenu.style.display = 'none';
        }
    });
  
 });


// LEEP NEWタグ
const NEW_TAG_DAYS = 30;
const NEW_TAG_TEXT = 'NEW';
const DELAY_MS = 1000;

function addNewTags() {
  const dateElements = document.querySelectorAll('.LeeepListDate');
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const cutoffDate = new Date(today);
  cutoffDate.setDate(today.getDate() - NEW_TAG_DAYS);

  dateElements.forEach((element) => {
    // 要素のテキスト内容を取得
    const dateText = element.textContent.trim();
    
    const [year, month, day] = dateText.split('/').map(Number);
    const elementDate = new Date(year, month - 1, day);
    elementDate.setHours(0, 0, 0, 0);
    
    // 日付を比較
    if (elementDate >= cutoffDate && elementDate <= today) {
      // NEWタグを追加
      const newLabel = document.createElement('span');
      newLabel.textContent = ` ${NEW_TAG_TEXT}`;
      newLabel.className = 'new-tag';
      element.appendChild(newLabel);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    addNewTags();
  }, DELAY_MS);
});